import { BaseLink } from '@/navigation';
import { ComponentProps, Suspense } from 'react';
import { ClientOnlyLink } from './index';

const protectedRoutes = ['/product/create', '/products/my', '/product/edit'];

// Utility: check if the route is protected
function isProtected(href: string): boolean {
  return protectedRoutes.some((route) => href.startsWith(route));
}

type AppLinkProps = ComponentProps<typeof BaseLink>;

export function Link(props: AppLinkProps) {
  const href = String(props.href);

  const isProtectedRoute = isProtected(href);

  if (!isProtectedRoute) {
    // Unprotected route, no suspense needed
    return <BaseLink {...props} />;
  }

  return (
    <Suspense fallback={<BaseLink {...props} />}>
      <ClientOnlyLink {...props} />
    </Suspense>
  );
}
